import React from 'react';
import { Button } from '@smarterservices/smarter-ui';
import { SETTINGS_LINKS } from '../constants';

interface OSSettingsButtonProps {
  /**
   * Operating system ('windows', 'mac', or other)
   */
  os?: string;
  
  /**
   * Device type ('camera' or 'microphone')
   */
  deviceType: 'camera' | 'microphone';
  
  /**
   * Button size ('small', 'medium', 'large')
   */
  size?: 'small' | 'medium' | 'large';
  
  /**
   * Button color ('primary', 'primary-inverse', 'secondary', 'success', 'danger')
   */
  color?: 'primary' | 'primary-inverse' | 'secondary' | 'success' | 'danger';
}

/**
 * OSSettingsButton component for opening OS device settings
 * 
 * @param {OSSettingsButtonProps} props - Component props
 * @returns {React.ReactElement} Button component for OS settings
 */
const OSSettingsButton: React.FC<OSSettingsButtonProps> = ({ 
  os = 'windows', 
  deviceType,
  size = 'small', 
  color = 'primary' 
}) => {
  let settingsUri = '#';
  
  if (os.toLowerCase() === 'windows') {
    settingsUri = SETTINGS_LINKS[deviceType].windows;
  } else if (os.toLowerCase() === 'mac') {
    settingsUri = SETTINGS_LINKS[deviceType].mac;
  }

  return (
    <Button
      size={size}
      color={color}
      onClick={() => window.location.href = settingsUri}
      aria-label={`Open Operating System ${deviceType.charAt(0).toUpperCase() + deviceType.slice(1)} Settings`}
    >
      Open Settings
    </Button>
  );
};

export default OSSettingsButton;
